import { ShiftSchedule } from '@vyce/core/src/types';
import { isOverlapped } from '@vyce/core/src/utils/dates';

export const isScheduleValid = (
  regularSchedule?: ShiftSchedule,
  overtimeSchedule?: ShiftSchedule
): boolean => {
  let valid = true;
  if (!regularSchedule || !overtimeSchedule) {
    return false;
  }
  // @ts-ignore
  Object.keys(overtimeSchedule).forEach((key: keyof ShiftSchedule) => {
    if (isOverlapped(overtimeSchedule[key], regularSchedule[key])) {
      valid = false;
    }
  });
  return valid;
};
